import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "datatables.net-bs4"
import "chartkick/chart.js"
import Choices from 'choices.js'
// import 'choices.js/public/assets/styles/choices.min.css'


Rails.start()
ActiveStorage.start()

import 'bootstrap'

function requireAll(r) { r.keys().forEach(r) }
requireAll(require.context('./behaviors/', true, /\.js$/))
